import React, { useState } from 'react';
import { motion } from 'framer-motion';

function KeyBenefitsSection({ service }) {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!service) return null;

  const benefits = [
    {
      title: "Measurable Target Outcome",
      desc: service.outcome || `Accelerate enterprise agility and SLA compliance with best-practice ${service.title} architecture.`
    },
    {
      title: "Strategic Platform Velocity",
      desc: service.tagline || `Streamlined deployment designed around your enterprise workflows to reduce time-to-value.`
    },
    {
      title: "Enterprise Governance & Scalability",
      desc: service.capabilities?.[0]
        ? `Built on certified industry standards covering ${service.capabilities[0].toLowerCase()} with zero technical debt.`
        : "Engineered for 100% best-practice compliance and scalable operational sustainability."
    }
  ];

  return (
    <section className="bg-white overflow-hidden py-[0px] lg:py-[0px] font-sans mb-[50px]">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">
        <div className="mb-[35px] lg:mb-[45px]">
          <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2">
            The Mobikode Approach
          </p>
          <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2]">
            {service.title} for Digital Acceleration
          </h2>
        </div>
        <div className="relative w-full h-[380px] sm:h-[440px] lg:h-[480px] overflow-hidden bg-[#020D26] flex flex-col justify-end">

          {/* Background Graphic */}
          <img
            src="/assets/datab/bg3.png"
            alt="Section Background"
            className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none opacity-80"
          />

          {/* Bottom Tabs Strip */}
          <div className="relative z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-end">
            {benefits.map((benefit, index) => {
              const isActive = activeIndex === index;

              return (
                <div
                  key={index}
                  onMouseEnter={() => setActiveIndex(index)}
                  className={`cursor-pointer transition-all duration-300 border-t lg:border-t-0 border-[#FFFFFF] lg:border-r last:border-r-0 ${isActive
                    ? "bg-[#01386A] p-6 lg:p-7 min-h-[190px] lg:min-h-[220px] flex flex-col justify-between z-20"
                    : "bg-[#01386A] hover:bg-[#013260] p-5 lg:p-6 min-h-[75px] lg:min-h-[85px] flex items-center justify-start z-10"
                    }`}
                >
                  <h3 className="font-sora text-white text-[16px] lg:text-[20px] font-[600] leading-[1.3]">
                    {benefit.title}
                  </h3>

                  {isActive && benefit.desc && (
                    <motion.p
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      className="font-graphik font-[500] text-white/85 text-[14px] lg:text-[16px] leading-[1.6] mt-4"
                    >
                      {benefit.desc}
                    </motion.p>
                  )}
                </div>
              );
            })}
          </div>

        </div>

      </div>
    </section>
  );
}

export default KeyBenefitsSection;